import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SearchBarLogicReturn } from './SearchBar.types';
import { useTranslation } from '../../../redux/TranslationHelper';

/**
 * 검색창 컴포넌트 로직 훅
 */
const useSearchBarLogic = (componentData: any, mode: any): SearchBarLogicReturn => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  
  // URL 파라미터에서 t 값 추출
  const searchParams = new URLSearchParams(location.search);
  const urlSearchQuery = searchParams.get('t') || '';
  
  // props 추출
  const props = { ...componentData.props, ...componentData.componentProps, ...componentData };
  const {
    placeholder = '검색어를 입력하세요',
    buttonText = '검색',
    searchPath = '/searched'
  } = props;
  
  // 상태 관리
  const [searchQuery, setSearchQuery] = useState(urlSearchQuery);
  const [isLoading] = useState(false);
  
  // URL 파라미터가 변경되면 검색어 업데이트
  useEffect(() => {
    const newSearchParams = new URLSearchParams(location.search);
    const newUrlSearchQuery = newSearchParams.get('t') || '';
    setSearchQuery(newUrlSearchQuery);
  }, [location.search]);
  
  // 검색 실행 함수
  const handleSearch = useCallback(() => {
    if (searchQuery.trim()) {
      // 검색어가 있을 때만 이동
      const searchUrl = `${searchPath}?t=${encodeURIComponent(searchQuery.trim())}`;
      
      // componentData.utils?.navigate가 있으면 사용, 없으면 react-router navigate 사용
      if (componentData.utils?.navigate) {
        componentData.utils.navigate(searchUrl);
      } else {
        navigate(searchUrl);
      }
    }
  }, [searchQuery, searchPath, navigate, componentData.utils]);
  
  // 입력 변경 핸들러
  const handleInputChange = useCallback((value: string) => {
    setSearchQuery(value);
  }, []);
  
  // 엔터 키 핸들러
  const handleKeyPress = useCallback((e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  }, [handleSearch]);
  
  return {
    data: {
      searchQuery,
      placeholder: t(placeholder),
      buttonText: t(buttonText),
      isLoading
    },
    actions: {
      handleSearch,
      handleInputChange,
      handleKeyPress
    }
  };
};

export default useSearchBarLogic;